import { useMemo } from 'react';

import { useFormVersionTipsForPeriod } from 'components/IAP/hooks/icsFormVersionHooks';
import { buildFormCompletion } from 'components/IAP/femaCards/formSignatureCompletion';
import { IAP_COVER_BASE_ID } from '../IapCoverSheet/iapCoverForm';
import { parseWalaSignatures } from './ics204SignatureSlots';

/**
 * True when this period's IAP cover is fully signed.
 *
 * Assigned stays closed until then. A missing cover, or one still in draft, is not approved.
 */
export function useIapCoverApproved(periodNumber: number): boolean {
  const { data: tips = [] } = useFormVersionTipsForPeriod(periodNumber);
  return useMemo(() => {
    const cover = tips.find((tip) => tip.formBaseId === IAP_COVER_BASE_ID);
    if (!cover) return false;
    return (
      buildFormCompletion(
        cover.signatureSlots,
        parseWalaSignatures(cover.signatures)
      ).status === 'signed'
    );
  }, [tips]);
}
